<template>
    <ul class="nav">
        <li class="nav-item">
            <a class="nav-link" :href="docUrl" target="_blank">
                Documentation
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="http://traxlrs.com" target="_blank">
                Website
            </a>
        </li>
        <li class="nav-item" v-if="showVersion">
            <span class="nav-link version">{{ version }}</span>
        </li>
    </ul>
</template>

<script>
    export default {

        props: {
            showVersion: {
                type: Boolean,
                default: false
            }
        },

        computed: {

            docUrl() {
                return this.$appEnv == 'local'
                    ? this.$baseURL + '/docs'
                    : 'http://extended.traxlrs.com/docs/2.1/license'
            },

            version() {
                return 'v' + this.$appVersion
            },
        }
    }
</script>

<style scoped>

    .nav {
        justify-content: center;
    }
    .version, .version:hover {
        color: #525f7f !important;
    }
    
</style>
